import React from "react";

export default function Designer() {
  return (
    <section className="designer-section">
      <div className="container">
        <div className="row align-items-start">
          <div className="col-lg-5 col-md-5">
            <img src="/image/sonam.webp" className="img-responsive" alt="Sonam Brahme" loading="lazy" />
          </div>

          <div className="col-lg-7 col-md-7">
            <div className="aboutemotion-text">
              <h2 className="heading">The Woman Behind the Thread</h2>

              <p>
                Sonam Brahme designs with a rare combination of intuition and intention, shaping every piece to feel
                personal, soulful, and truly unforgettable. As an upcoming luxury couturier, she chooses to remain
                selectively available, so that every bride she works with receives her undivided attention.
              </p>

              <p className="gradient-color">
                &ldquo;To every bride and every mother visiting, know this - your journey, your hopes, and your quiet
                expectations guide my hands. My work is simply an extension of your love and your dreams.&rdquo;
                <br />
                &mdash; Sonam Brahme
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
